/**
 * @name Notes Config
 * @memberof module:common/config
 * @type {Config}
 * @return {Object} Configurations of API
 */

import { API } from '../config';

export const base = `${API.BASE_DEV_HOST}/api/notes`;

export const list = `${base}/list`;
export const save = `${base}/`;

export const getNotes = (pageType: string, pageTypeKey: string, pageTypeValue: number) => {
  // Keys sorted to match the previous query-string output. This module stays
  // dependency-free because the Playwright suite imports it for the route.
  const query: Record<string, string | number> = { page_type: pageType, [pageTypeKey]: pageTypeValue };
  const params = new URLSearchParams(
    Object.keys(query)
      .sort()
      .map(key => [key, String(query[key])])
  );
  return `${list}?${params.toString()}`;
};
